"use strict";
exports.__esModule = true;
var GoogleScopeEnum;
(function (GoogleScopeEnum) {
    GoogleScopeEnum["GmailModify"] = "https://www.googleapis.com/auth/gmail.modify";
    GoogleScopeEnum["GmailCompose"] = "https://www.googleapis.com/auth/gmail.compose";
    GoogleScopeEnum["GmailSend"] = "https://www.googleapis.com/auth/gmail.send";
    GoogleScopeEnum["Calendar"] = "https://www.googleapis.com/auth/calendar";
})(GoogleScopeEnum || (GoogleScopeEnum = {}));
exports["default"] = GoogleScopeEnum;
//# sourceMappingURL=google-scope-enum.js.map